(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});
  DNB.KompozitPage = {
    init: function () {
      var root = document.querySelector(".page-body__content[data-page-kompozit]");
      var modal = document.getElementById("kompozitRenkModal");
      if (!root || !modal) return;
      if (root.getAttribute("data-kompozit-init") === "1") return;
      root.setAttribute("data-kompozit-init", "1");

      if (DNB.KompozitKartela && DNB.KompozitKartela.ensure) {
        DNB.KompozitKartela.ensure();
      }

      this._bindRenkTriggers(root);
      this._bindDownloads(root);
    },

    _isRenkTrigger: function (el) {
      if (!el) return false;
      if (el.getAttribute("data-color-group") || el.getAttribute("data-kompozit-renk")) {
        return true;
      }
      if (el.getAttribute("aria-haspopup") === "dialog") {
        return true;
      }
      if (el.matches("button.info-card") && this._guessRenkGroup(el)) {
        return true;
      }
      return false;
    },

    _normalizeGroupKey: function (key) {
      return String(key || "")
        .trim()
        .replace(/\s+/g, "")
        .replace(/[,/]/g, "-")
        .replace(/[\u2010-\u2015\u2212–—]/g, "-");
    },

    _resolveKartelaConfig: function (groupKey) {
      var map = {
        "100-200": { group: "100,200", series: "100" },
        "300-400": { group: "300,400", series: "400" },
        "100": { group: "100,200", series: "100" },
        "200": { group: "100,200", series: "200" },
        "300": { group: "300,400", series: "300" },
        "400": { group: "300,400", series: "400" }
      };
      groupKey = this._normalizeGroupKey(groupKey);
      if (map[groupKey]) {
        return map[groupKey];
      }
      var nums = String(groupKey || "").match(/\d+/g);
      if (nums && nums.length >= 2) {
        var pair = nums[0] + "-" + nums[1];
        if (map[pair]) {
          return map[pair];
        }
      }
      if (nums && nums.length === 1 && map[nums[0]]) {
        return map[nums[0]];
      }
      return map["100-200"];
    },

    _renkGroupKey: function (el) {
      var fromAttr =
        el.getAttribute("data-color-group") ||
        el.getAttribute("data-kompozit-renk");
      if (fromAttr) {
        return this._normalizeGroupKey(fromAttr);
      }
      return this._guessRenkGroup(el);
    },

    _bindRenkTriggers: function (root) {
      var self = this;

      root.addEventListener("click", function (e) {
        var card = e.target.closest(
          "[data-color-group], [data-kompozit-renk], button.info-card, .info-card"
        );
        if (!card || !self._isRenkTrigger(card)) {
          return;
        }

        var key = self._renkGroupKey(card);
        if (!key) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        self._openKartela(key, card);
      });
    },

    _guessRenkGroup: function (el) {
      var text = (el.textContent || "").toLowerCase().replace(/\s+/g, " ");
      if (text.indexOf("300/400") >= 0) {
        return "300-400";
      }
      if (text.indexOf("100/200") >= 0) {
        return "100-200";
      }
      if (text.indexOf("pb:") >= 0 && text.indexOf("rb:") >= 0) {
        return "300-400";
      }
      if (text.indexOf("ab:") >= 0 && text.indexOf("sb:") >= 0) {
        return "100-200";
      }
      if (text.indexOf("renk seçenek") >= 0 && text.indexOf("300") >= 0) {
        return "300-400";
      }
      if (text.indexOf("renk seçenek") >= 0 && text.indexOf("100") >= 0) {
        return "100-200";
      }
      return null;
    },

    _openKartela: function (groupKey, triggerEl) {
      var modal = document.getElementById("kompozitRenkModal");
      if (!modal) return;

      var cfg = this._resolveKartelaConfig(groupKey);
      if (triggerEl) {
        var seriesOverride =
          triggerEl.getAttribute("data-default-series") ||
          triggerEl.getAttribute("data-kompozit-series");
        if (seriesOverride) {
          cfg.series = String(seriesOverride).trim();
        }
      }
      if (DNB.KompozitKartela && DNB.KompozitKartela.apply) {
        DNB.KompozitKartela.apply(cfg.group, cfg.series);
      }

      if (DNB.Modal && typeof DNB.Modal.open === "function") {
        DNB.Modal.open("kompozitRenkModal");
        return;
      }

      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("has-modal-open");
      if (DNB.ScrollService && DNB.ScrollService.lock) {
        DNB.ScrollService.lock();
      }
    },

    _bindDownloads: function (root) {
      var self = this;
      var files = this._readFiles();
      if (!files.length) return;

      var byKey = {};
      files.forEach(function (f) {
        if (f.key) byKey[f.key.toLowerCase()] = f;
      });

      var cards = root.querySelectorAll("a.info-card, [data-kompozit-download]");
      var fileIndex = 0;
      cards.forEach(function (card) {
        if (self._isRenkTrigger(card)) return;
        if (card.getAttribute("data-kompozit-download-bound") === "1") return;
        card.setAttribute("data-kompozit-download-bound", "1");

        var key = (card.getAttribute("data-cms-file-key") || "").trim().toLowerCase();
        var file = key ? byKey[key] : files[fileIndex];
        fileIndex += 1;
        if (!file || !file.url) return;

        var href = file.url.indexOf("/") === 0 ? file.url : "/" + file.url;
        card.setAttribute("href", href);
        card.setAttribute("download", "");
        card.setAttribute("target", "_blank");
        card.setAttribute("rel", "noopener noreferrer");

        var titleEl = card.querySelector(".info-card__title");
        if (titleEl && file.title && !card.hasAttribute("data-cms-file-key")) {
          titleEl.textContent = file.title;
        }
      });
    },

    _readFiles: function () {
      var el = document.getElementById("kompozit-page-files");
      if (!el || !el.textContent) return [];
      try {
        return JSON.parse(el.textContent);
      } catch (err) {
        return [];
      }
    }
  };
})(window, document);
